import context from './main.base';
import { IAppUserContext } from './IAppUserContext';

context.initialize().then(() => {
    (window as any).isSysInitialized = true;
    console.log('System initialized');
});

export * from './main.base';

export default context as IAppUserContext;
